module.exports = __webpack_public_path__ + "24b1d52f2db3c762f00d2695ee052745.pdf";